// extracted by mini-css-extract-plugin
module.exports = {"markdownList":"html-text-markdown_markdownList__2vv8G","dark":"html-text-markdown_dark__4X0_t","markdownTable":"html-text-markdown_markdownTable__jK89h"};